import { render, staticRenderFns } from "./free-vip-dialog.vue?vue&type=template&id=54db6e96&scoped=true"
import script from "./free-vip-dialog.vue?vue&type=script&lang=js"
export * from "./free-vip-dialog.vue?vue&type=script&lang=js"
import style0 from "./free-vip-dialog.vue?vue&type=style&index=0&id=54db6e96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db6e96",
  null
  
)

export default component.exports